import React from "react";
import Icon from "components/AppIcon";

const STATUS_STEPS = [
  { key: "submitted", label: "Submitted", icon: "Send" },
  { key: "processing", label: "Processing", icon: "Settings" },
  { key: "shipped", label: "Shipped", icon: "Truck" },
  { key: "delivered", label: "Delivered", icon: "CheckCircle" },
];

export default function OrderTracker({ orders }) {
  const getStepIndex = (status) => STATUS_STEPS?.findIndex((s) => s?.key === status);

  return (
    <div className="card p-4 md:p-6">
      <h3 className="font-heading font-semibold text-base text-foreground flex items-center gap-2 mb-4">
        <Icon name="Package" size={18} color="var(--color-primary)" strokeWidth={2} />
        Order Fulfillment Tracker
      </h3>
      <div className="space-y-4">
        {orders?.map((order) => {
          const currentStep = getStepIndex(order?.status);
          return (
            <div key={order?.id} className="border border-border rounded-md p-3 md:p-4">
              <div className="flex items-start justify-between mb-3 gap-2">
                <div>
                  <p className="font-caption text-sm font-semibold text-foreground">{order?.id}</p>
                  <p className="font-caption text-xs text-muted-foreground">{order?.account}</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="font-data text-sm font-semibold text-primary">₱{order?.total?.toLocaleString("en-PH", { minimumFractionDigits: 2 })}</p>
                  <p className="font-caption text-xs text-muted-foreground">{order?.date}</p>
                </div>
              </div>
              <div className="flex items-center gap-0">
                {STATUS_STEPS?.map((step, idx) => {
                  const isCompleted = idx <= currentStep;
                  const isCurrent = idx === currentStep;
                  return (
                    <React.Fragment key={step?.key}>
                      <div className="flex flex-col items-center flex-shrink-0">
                        <div className={`w-7 h-7 rounded-full flex items-center justify-center transition-colors ${isCompleted ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground"} ${isCurrent ? "ring-2 ring-primary ring-offset-1" : ""}`}>
                          <Icon name={step?.icon} size={13} color="currentColor" strokeWidth={2} />
                        </div>
                        <span className={`font-caption text-xs mt-1 whitespace-nowrap ${isCompleted ? "text-primary font-medium" : "text-muted-foreground"}`}>
                          {step?.label}
                        </span>
                        {isCurrent && order?.timestamp && (
                          <span className="font-caption text-xs text-muted-foreground">{order?.timestamp}</span>
                        )}
                      </div>
                      {idx < STATUS_STEPS?.length - 1 && (
                        <div className={`flex-1 h-0.5 mx-1 mb-4 ${idx < currentStep ? "bg-primary" : "bg-border"}`} />
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}